export default {
  fontFamily: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  htmlFontSize: 11,
  fontSize: 11,
  useNextVariants: true,
  h1: {
    fontSize: 28,
    fontWeight: 700,
  },
  h2: {
    fontSize: 24,
    fontWeight: 700,
  },
  h3: {
    fontSize: 20,
    fontWeight: 700,
  },
  h4: {
    fontSize: 18,
    fontWeight: 700,
  },
  h5: {
    fontSize: 16,
    fontWeight: 700,
  },
  h6: {
    fontWeight: 500,
    fontSize: 11,
  },
  subtitle1: {
    fontWeight: 600,
    fontSize: 20,
  },
  subtitle2: {
    fontWeight: 600,
    fontSize: 12,
  },
  body2: {
    fontSize: 11,
  },
  overline: {
    fontWeight: 500
  }
};
